import { z, ZodTypeAny } from 'zod'
import { ShapeBase } from '~/prix/types/expression'

export const actionListDefaultInput = z.object({
  startIndex: z.number().min(0).optional(),
  stopIndex: z.number().min(1).optional(),
  orderBy: z.string().trim().optional(),
  order: z.string().trim().optional(),
  search: z.string().trim().optional(),
})

export type ActionListDefaultInputZodType = typeof actionListDefaultInput
export type ActionListDefaultInputType = z.infer<ActionListDefaultInputZodType>
/**
 *
 * @param listItems
 * @returns
 */
export function actionListInput<NativeGeneric extends ShapeBase>(
  listItems: NativeGeneric,
): ZodTypeAny {
  return z
    .object({
      ...listItems,
    })
    .merge(actionListDefaultInput)
    .refine(
      data => {
        const startIndex = data?.startIndex ?? 0
        const stopIndex = data?.stopIndex ?? 50
        return stopIndex > startIndex
      },
      {
        message: 'stopIndex must be greater than startIndex',
        path: ['stopIndex'],
      },
    )
}

export function actionListOutput(listItems: ZodTypeAny) {
  return z.object({
    items: listItems.optional(),
    totalItems: z.number().optional(),
  })
}
